import React, { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import "./cart-segment-warning-modal.css";

const CartSegmentWarningModal = ({
  show,
  onClose,
  onConfirm,
  storeName = "",
  submitting = false,
}) => {
  const dialogRef = useRef(null);
  const titleId = useId();
  const descriptionId = useId();

  useEffect(() => {
    if (!show) return undefined;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialogRef.current?.querySelector("button")?.focus();
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }
      if (event.key === "Tab") {
        const buttons = [...dialogRef.current.querySelectorAll("button:not(:disabled)")];
        const first = buttons[0];
        const last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown, true);
      previousFocus?.focus();
    };
  }, [onClose, show]);

  if (!show) {
    return null;
  }

  return createPortal(
    <div className="cart-store-warning">
      <div
        ref={dialogRef}
        className="cart-store-warning__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
      >
        <div className="cart-store-warning__icon">
          <i className="ph ph-warning-circle" aria-hidden="true" />
        </div>
        <h3 id={titleId}>Change store?</h3>
        <div id={descriptionId}>
          <div className="cart-store-warning__store">
            <i className="ph ph-storefront" aria-hidden="true" />
            <div>
              <span>Current cart</span>
              <strong>{storeName || "Your current store"}</strong>
            </div>
          </div>
          <p>Changing the branch/store will clear your previous cart. Do you want to continue?</p>
        </div>
        <div className="cart-store-warning__actions">
          <button
            type="button"
            className="cart-store-warning__cancel"
            onClick={onClose}
          >
            No, keep cart
          </button>
          <button
            type="button"
            className="cart-store-warning__confirm"
            onClick={onConfirm}
            disabled={submitting}
          >
            Yes, continue
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CartSegmentWarningModal;
